<template>
	<b-card no-body>
		<b-card-header>
			<b-card-title>Chick Placement V/s Sale</b-card-title>
			<div>
				<div class="d-flex">
					<div class="d-flex align-items-center mr-1 font-weight-bold">Year</div>

					<v-select
						v-model="selected"
						label="year"
						:options="option"
						style="width: 120px"
						@input="getSelectedYear"
					></v-select>
				</div>
			</div>
		</b-card-header>

		<!-- chart -->
		<b-card-body class="position-relative">
			<div v-if="loading" class="text-center py-4">
				<b-spinner variant="primary" />
			</div>
			<template v-else>
				<b-badge v-if="!hasData" variant="light-warning" class="chart-no-activity-badge">
					No activity for {{ selected }}
				</b-badge>
				<vue-apex-charts type="area" height="350" :options="chartOptions" :series="series" :plugins="plugins" />
			</template>
		</b-card-body>
	</b-card>
</template>

<script>
import { BCard, BCardHeader, BCardBody, BCardSubTitle, BCardTitle, BRow, BCol, BFormGroup, BSpinner, BBadge } from "bootstrap-vue";
import vmson from "@/libs/empty";
import vSelect from "vue-select";
import { $themeColors } from "@themeConfig";
import VueApexCharts from "vue-apexcharts";
import axiosIns from "@/libs/axios";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
export default {
	components: {
		BCard,
		BCardHeader,
		BCardBody,
		BCardSubTitle,
		BCardTitle,

		BRow,
		BCol,
		BFormGroup,
		BSpinner,
		BBadge,
		vSelect,
		VueApexCharts,
	},
	data() {
		const currentYear = new Date().getFullYear();
		const pastYears = 10; // Adjust the number of past years you want to include
		const options = [];

		// Generating options for current year and past years
		for (let i = 0; i < pastYears; i++) {
			options.push(currentYear - i);
		}
		return {
			selected: currentYear, // Default selection set to current year
			option: options,
			min: "",
			max: "",
			loading: true,
			hasData: false,
			plugins: [
				// to add spacing between legends and chart
				{
					beforeInit(chart) {
						/* eslint-disable func-names, no-param-reassign */
						chartOptions.legend.afterFit = function () {
							this.height += 20;
						};
						/* eslint-enable */
					},
				},
			],

			series: [
				{
					name: "Chick Placement",
					data: [],
				},
				{
					name: "Chick Sale",
					data: [],
				},
			],
			chartOptions: {
				chart: {
					height: 350,
					type: "area",
					toolbar: {
						show: false,
					},
					animations: {
						enabled: true,
						easing: "easeinout",
						speed: 600,
						animateGradually: {
							enabled: true,
							delay: 150,
						},
						dynamicAnimation: {
							enabled: true,
							speed: 350,
						},
					},
				},
				colors: ["#7367f0", "#28c76f"],
				dataLabels: {
					enabled: false,
				},
				stroke: {
					curve: "smooth",
					width: [3, 2],
				},
				fill: {
					type: "gradient",
					gradient: {
						shadeIntensity: 1,
						opacityFrom: 0.35,
						opacityTo: 0.05,
						stops: [0, 90, 100],
					},
				},
				grid: {
					borderColor: "#ebe9fe",
					strokeDashArray: 4,
				},
				markers: {
					size: 4,
					strokeWidth: 2,
					hover: { size: 6 },
				},
				tooltip: {
					shared: true,
					intersect: false,
				},
				xaxis: {
					categories: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
					// title: {
					//   text: "Month",
					// },
				},
				yaxis: {
					min: 0,
				},
				legend: {
					position: "top",
					horizontalAlign: "left",
					align: "start",
					display: true,
					labels: {
						usePointStyle: true,
						padding: 15,
						boxWidth: 7,
					},
				},
			},
		};
	},
	created() {
		this.farmId = this.$route.params.farmId;
		this.getData();
	},
	methods: {
		getSelectedYear(event) {
			this.selected = event;
			this.getData();
		},
		getData(id) {
			let farmId = id;
			let url = "";
			let type = 1;
			// type is production type of broiler
			if (farmId === undefined) {
				farmId = this.$route.params.farmId;
			} else {
				farmId = id;
			}
			if (farmId) {
				url = `web/chick-placement-sale?year=${this.selected}&farmId=${farmId}&type=${type}`;
			} else {
				url = `web/chick-placement-sale?year=${this.selected}&type=${type}`;
			}
			this.loading = true;
			this.$http
				.get(url)
				.then((response) => {
					const rows = Array.isArray(response.data) ? response.data : [];
					let chickPlacement = [];
					let chickSale = [];
					rows.forEach((item) => {
						chickPlacement.push(item.chick_placement);
						chickSale.push(Math.floor(item.bird_sale));
					});
					this.hasData = chickPlacement.some((v) => Number(v) > 0) || chickSale.some((v) => Number(v) > 0);
					let mapGraph = this.series.map((item) => {
						if (item.name === "Chick Placement") {
							item.data = chickPlacement;
						} else {
							item.data = chickSale;
						}
						return item;
					});
					this.series = [...mapGraph];
				})
				.catch(() => {
					this.hasData = false;
				})
				.finally(() => {
					this.loading = false;
				});
		},
		getFarmById() {
			const farm_id = this.$route.params.farmId;
			axiosIns
				.get(`web/chick-placement-sale?year=${this.selected}`, {
					params: { farmId: id },
				})
				.then((response) => {
					this.info = response.data;
					this.carouselItems = response.data.sliderList;
				})
				.catch((error) => {
					this.$toast({
						component: ToastificationContent,
						position: "top-right",
						props: {
							icon: "CoffeeIcon",
							variant: "danger",
							text:
								error.response?.data?.message ||
								error.response?.data?.error ||
								(error.response?.data?.errors
									? Object.values(error.response.data.errors).flat().join(", ")
									: "Something went wrong. Please try again."),
						},
					});
				});
		},
	},
	mounted() {
		vmson.$on("farmIdEvent", (id) => {
			this.getData(id);
		});
	},
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
.chart-no-activity-badge {
	position: absolute;
	top: 14px;
	right: 24px;
	z-index: 2;
}
</style>
